import styled from 'styled-components'

const Sheet = ({ 
  className,
  height,
  width,
  src
 }) => {
  return (<S_SheetContainer>
    <S_Sheet
      className={className}
      height={height}
      width={width}
      src={src}
    />
    <S_Blocker />
  </S_SheetContainer>)
}

export default Sheet

const S_SheetContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
`

const S_Blocker = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50px;
  background: white;
`

const S_Sheet = styled.iframe`
  width: 100%;
  height: 400px;
  border: none;
  height: ${props => props.height + 'px'};
  width: ${props => props.width + 'px'};
  /* outline: 1px solid black; */
`